export const projects = [
  {
    id: 0,
    name: "Somthing.Ai",
    image:
      "https://github.com/cheungjoshua/profile_v2/blob/newDesign/src/image/somthingAI.png?raw=true",
    describe:
      "A powerful AI chat application that enables human-like conversation with fully animated AI characters!",
    link: "https://github.com/cheungjoshua/somthing_ai",
    location: "Repo",
    stack: "React, Express, Node, SASS, PSQL, HTML, Javascript",
  },
  {
    id: 1,
    name: "Woods",
    image:
      "https://github.com/cheungjoshua/profile_v2/blob/newDesign/src/image/woods.png?raw=true",
    describe:
      "A place where user can store and view helpful resources, allow for a quick access to sites. Post good stuff.",
    link: "https://github.com/cheungjoshua/resource_wall",
    location: "Repo",
    stack: "EJS, Express, Node, Tailwind, PSQL, HTML, Javascript",
  },
  {
    id: 3,
    name: "Simple Movie App",
    image:
      "https://github.com/cheungjoshua/profile_v2/blob/newDesign/src/image/simple_movie.png?raw=true",
    describe:
      "A simple movie app that user can render movies in different category by click the genre from the drop down menu in Nav.",
    link: "https://simple-movie-app-by-josh.netlify.app/",
    location: "Live",
    stack: "React, HTML, SASS, Axios, Javascript",
  },
  {
    id: 4,
    name: "MERN Todo App",
    image:
      "https://github.com/cheungjoshua/profile_v2/blob/newDesign/src/image/mern_todo.png?raw=true",
    describe:
      "TODO app with MERN stack, user able to ADD, EDIT, DELETE, SEARCH Todo. App style without using CSS.",
    link: "https://github.com/cheungjoshua/mern-todo",
    location: "Repo",
    stack: "React, Express, Node, MongoDB",
  },
  {
    id: 2,
    name: "Scheduler",
    image:
      "https://github.com/cheungjoshua/profile_v2/blob/newDesign/src/image/scheduler.png?raw=true",
    describe:
      "Interview Scheduler is a responsive single-page application (SPA) build with React. A user can book an interview appointment for a specific day of the week. The user can also edit or delete their appointment.",
    link: "https://github.com/cheungjoshua/scheduler",
    location: "Repo",
    stack: "React, Express, Node, SASS, PSQL, HTML, Javascript",
  },
];
